module.exports = __webpack_public_path__ + "img/09.7ec49069.jpg";